import { EMAIL, WHATSAPP_DISPLAY, LOCATION } from "@/data/content";

export const Footer = () => (
  <footer data-testid="footer" className="relative bg-[var(--ink)] border-t border-white/10 overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-16 pb-10">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
        <img src="/assets/logo-light.png" alt="FMACIEL Consultoria e Projetos" className="h-40 md:h-48 w-auto self-start logo-glow" />
        <div className="font-mono text-sm text-[var(--steel-2)] space-y-2 md:text-right">
          <p>{EMAIL}</p>
          <p>{WHATSAPP_DISPLAY}</p>
          <p data-testid="footer-location">{LOCATION}</p>
        </div>
      </div>
      <p aria-hidden className="mt-12 font-display font-black uppercase leading-none text-[19vw] md:text-[15vw] text-transparent [-webkit-text-stroke:1px_rgba(226,232,240,0.12)] select-none">FMACIEL</p>
      <div className="mt-6 flex flex-col sm:flex-row justify-between gap-3 font-mono text-xs uppercase tracking-[0.2em] text-[var(--steel-2)]">
        <span>© {new Date().getFullYear()} FMACIEL Consultoria e Projetos</span>
        <span>Engenharia que transforma projetos em resultados</span>
      </div>
    </div>
  </footer>
);
